import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface IState {
  systems: any[];
  companies: any[];
}

const initialState: IState = {
  systems: ["ثبت تخلف سرعت"],
  companies: ["گصن"],
};

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    changeSysCode: (state, action: PayloadAction<any>) => {
      return { ...state, systems: action.payload };
    },
    changeCompanyCode: (state, action: PayloadAction<any>) => {
      return { ...state, companies: action.payload };
    },
  },
});

export const { changeSysCode, changeCompanyCode } = reportsSlice.actions;

export default reportsSlice.reducer;
